import React, { Fragment, useMemo, useState } from 'react'
import styled, { css } from 'styled-components'
import Colors from '../../constants/Colors'
import NotFoundPrize from './components/NotFoundPrize'
import FoundPrize from './components/FoundPrize'
import Print from './components/Print'
import Swal from 'sweetalert2'

const NEW_WINDOW_STYLE = css`
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #fafafa;
    font-family: Arial, Helvetica, sans-serif;
  }

  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .paper-print {
    width: 21cm;
    min-height: 29.7cm;
    padding: 0 0 0 3.2cm;
    margin: 10mm auto;
    border: 1px #d3d3d3 solid;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }

  .sub-paper-print {
    padding: 0;
    min-height: 297mm;
  }

  @page {
    size: A4;
    margin: 0;
  }

  @media print {
    html,
    body {
      width: 21cm;
      height: 29.7cm;
    }

    .paper-print {
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      min-height: initial;
      box-shadow: initial;
      background: initial;
      page-break-after: always;
    }
  }

  .row-print-container {
    font-size: 8px;
    letter-spacing: 1px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .container-print-container {
    border: 0.03cm solid #808080;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 169.78px;
    padding-top: 0.3cm;
    padding-bottom: 0.1cm;
  }

  .container-print-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 8.3cm;
    border-top: black 1px solid;
    border-left: black 1px solid;
    text-align: center;
    height: 100%;
  }

  .container-print-grid {
    display: grid;
    grid-template-columns: 1fr 9fr;
  }

  .container-print-grid div {
    border-right: black 1px solid;
    border-bottom: black 1px solid;
    line-height: 0.3cm;
  }

  .item-not-prize-text {
    color: #ffffff;
    background-color: #ff0000;
    display: inline-block;
    width: 100%;
  }

  .full-name-in-container {
    display: flex;
    justify-content: space-between;
    width: 8.3cm;
    padding-top: 0.1cm;
  }

  .full-name-below-paper {
    font-size: 12px;
    letter-spacing: 1px;
    margin-top: 0.5cm;
  }

  .group-prize-name {
    display: flex;
    flex-direction: column;
    margin-top: 0.5cm;
  }
`

const Verify = ({ lotteries, setLotteries, handleClickRemoveSomeLottery }) => {
  const [fullNameInContainer, setFullNameInContainer] = useState(localStorage.getItem('fullNameInContainer') || '')
  const [fullNameBelowPaper, setFullNameBelowPaper] = useState(localStorage.getItem('fullNameBelowPaper') || '')

  const isDisabledButton = useMemo(() => {
    return fullNameInContainer === '' || fullNameBelowPaper === ''
  }, [fullNameInContainer, fullNameBelowPaper])

  const { notFoundPrize, foundPrize, manyPrizesAtSameNumber } = useMemo(() => {
    const notFound = []
    const found = {}
    const manyPrizesAtSameNumber = {}

    lotteries.forEach((lotto, index) => {
      const { prizeName } = lotto

      if (prizeName === 'notFound') {
        notFound.push({ ...lotto, index })
      } else {
        if (!found[prizeName]) {
          found[prizeName] = []
        }

        found[prizeName].push({ ...lotto, index })
      }
    })

    for (const key in found) {
      if (key.includes(',')) {
        manyPrizesAtSameNumber[key] = found[key]
      }
    }

    return { notFoundPrize: notFound, foundPrize: found, manyPrizesAtSameNumber }

  }, [lotteries])

  const onSaveFullNameOnLocalStorage = () => {
    localStorage.setItem('fullNameInContainer', fullNameInContainer)
    localStorage.setItem('fullNameBelowPaper', fullNameBelowPaper)
  }

  const handleClickPrintPrizeOnNewTab = () => {
    onSaveFullNameOnLocalStorage()

    let element = document.getElementById('print-area').innerHTML
    let newWindow = window.open('', '_blank')

    newWindow.document.write(`<html><head><title>ตัวอย่างการพิมพ์</title>
    <style>
      ${NEW_WINDOW_STYLE}
    </style>
    </head><body>`)

    newWindow.document.body.innerHTML = element
    newWindow.document.write('</body></html>')
    newWindow.print()
  }

  const handleClickShowManyPrizesAtSameNumber = () => {
    let html = ''

    Object.keys(manyPrizesAtSameNumber).forEach((prizeName) => {
      const prizes = manyPrizesAtSameNumber[prizeName]
      let title = `<div>${prizeName} มี ${prizes.length} ใบ</div>`
      let items = ''

      prizes.forEach((prize) => items += `<div>${prize.lotteryId}</div>`)
      html += title + items + '<br />'
    })

    Swal.fire({
      title: 'รางวัลที่มีหลายรางวัลในเลขเดียวกัน',
      html,
      confirmButtonText: 'ปิด',
    })
  }

  return (
    <Fragment>
      <hr />
      <VerifyPrizeForm>
        <h3>ตัวอย่างการพิมพ์</h3>
        <input type="text" value={fullNameInContainer} onChange={(e) => setFullNameInContainer(e.target.value)} placeholder="ชื่อ-นามสกุล แสดงมุมซ้ายล่างตาราง" className="prize-input-full-name" />
        <input type="text" value={fullNameBelowPaper} onChange={(e) => setFullNameBelowPaper(e.target.value)} placeholder="ชื่อ-นามสกุล แสดงมุมซ้ายล่างกระดาษ" className="prize-input-full-name" />
        <Button color={Colors.SOFT_BLUE} onClick={handleClickPrintPrizeOnNewTab} disabled={isDisabledButton}>ตัวอย่างการพิมพ์</Button>
        <span id="print-area">
          <Print lotteries={lotteries} fullNameInContainer={fullNameInContainer} fullNameBelowPaper={fullNameBelowPaper} foundPrize={foundPrize} />
        </span>
      </VerifyPrizeForm>
      <hr />
      {notFoundPrize.length > 0 && <NotFoundPrize lotteries={lotteries} notFoundPrize={notFoundPrize} setLotteries={setLotteries} handleClickRemoveSomeLottery={handleClickRemoveSomeLottery} />}
      <hr />
      {Object.keys(manyPrizesAtSameNumber).length > 0 && (<Button color={Colors.ORANGE} className="mb-2" onClick={handleClickShowManyPrizesAtSameNumber}>แสดงรางวัลที่มีหลายรางวัลในเลขเดียวกัน</Button>)}
      {Object.keys(foundPrize).length > 0 && <FoundPrize foundPrize={foundPrize} handleClickRemoveSomeLottery={handleClickRemoveSomeLottery} />}
    </Fragment>
  )
}

export default Verify

const VerifyPrizeForm = styled.div`
  margin-top: 3em;
  margin-bottom: 3em;

  h3 {
    text-align: center;
  }
  
  .prize-input-full-name {
    width: 100%;
    height: 36px;
    border-radius: 3px;
    padding: 0 8px;
    margin-bottom: 1em;
    color: ${Colors.DARK_GREY};
    border: 1px solid ${Colors.LIGHT_GREY2};
  }
`

const Button = styled.button`
  width: 100%;
  font-size: 1em;
  font-weight: bold;
  padding: 0.25em 1em;
  border-radius: 3px;
  color: ${Colors.WHITE};
  border: 2px solid ${({ color }) => color};
  background-color: ${({ color }) => color};

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  
  :disabled {
    background: ${Colors.SOFT_WHITE};
    border: solid 1px ${Colors.LIGHT_GREY};
    color: ${Colors.LIGHT_GREY2};
    fill: ${Colors.LIGHT_GREY2};
  }
`
